import script from "./join_complete.vue?vue&type=script&setup=true&lang=js"
export * from "./join_complete.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__